var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import * as _ from 'lodash';
import * as API from './api';
let GroupManage = class GroupManage extends Vue {
    constructor() {
        super(...arguments);
        this.show_add_proitem = false;
        this.prosets = [];
        this.current_proset = null;
        this.current_proitems = [];
        this.available_problems = [];
        this.selected_problem = null;
        this.selected_deadline = null;
        this.selected_section = '';
    }
    fetchData(reset = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (reset) {
                this.current_proset = null;
                this.current_proitems = [];
            }
            let prosets_result = yield API.listProSet();
            if (prosets_result !== 'Error') {
                this.prosets = prosets_result;
            }
            if (!('proset_uid' in this.$route.params)) {
                this.current_proset = null;
            }
            else {
                let proset_uid = parseInt(this.$route.params['proset_uid']);
                let [proset_result, proitems_result] = yield Promise.all([
                    API.getProSet(proset_uid),
                    API.listProItem(proset_uid)
                ]);
                if (proset_result !== 'Error') {
                    this.current_proset = proset_result;
                }
                if (proitems_result !== 'Error') {
                    this.current_proitems = proitems_result;
                }
            }
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
        });
    }
    onCreateProSet() {
        return __awaiter(this, void 0, void 0, function* () {
            let proset_uid = yield API.createProSet('New Colle');
            if (proset_uid !== 'Error') {
                this.$router.push(`/manage/group/${proset_uid}/`);
            }
        });
    }
    onApplyProSet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.current_proset !== null) {
                if ((yield API.setProSet(this.current_proset)) === 'Success') {
                    yield this.fetchData();
                }
            }
        });
    }
    onToggleProSetHidden(proset) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Toggle Collection?')) {
                let modified_proset = _.cloneDeep(proset);
                modified_proset.hidden = !modified_proset.hidden;
                if ((yield API.setProSet(modified_proset)) === 'Success') {
                    proset.hidden = modified_proset.hidden;
                    alert('Toggle Success!');
                }
                else {
                    alert('Toggle Failed!');
                }
            }
        });
    }
    onRemoveProSet(proset) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Remove Collection?')) {
                if ((yield API.removeProSet(proset.uid)) === 'Success') {
                    this.$router.push(`/manage/group/`);
                    alert('Remove Success!');
                }
                else {
                    alert('Remove Failed!');
                }
            }
        });
    }
    onShowAddProItem() {
        return __awaiter(this, void 0, void 0, function* () {
            this.available_problems = [];
            this.selected_problem = null;
            this.selected_deadline = null;
            this.selected_section = '';
            this.show_add_proitem = true;
            let result = yield API.listProblem();
            if (result !== 'Error') {
                this.available_problems = result.map((data) => data.problem);
            }
        });
    }
    onAddProItem() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.current_proset !== null && this.selected_problem !== null) {
                let proset_uid = this.current_proset.uid;
                let proitem_uid = yield API.addProItem(proset_uid, this.selected_problem);
                if (proitem_uid !== 'Error') {
                    let proitem = yield API.getProItem(proset_uid, proitem_uid);
                    if (proitem !== 'Error') {
                        proitem.deadline = this.selected_deadline;
                        proitem.metadata = { section: this.selected_section };
                        if ((yield API.setProItem(proset_uid, proitem)) === 'Success') {
                            this.show_add_proitem = false;
                            yield this.fetchData(false);
                        }
                    }
                }
            }
        });
    }
    onToggleProItemHidden(proitem) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Toggle Problem?')) {
                if (this.current_proset !== null) {
                    let modified_proitem = _.cloneDeep(proitem);
                    modified_proitem.hidden = !modified_proitem.hidden;
                    if ((yield API.setProItem(this.current_proset.uid, modified_proitem)) === 'Success') {
                        proitem.hidden = modified_proitem.hidden;
                        alert('Toggle Success!');
                    }
                    else {
                        alert('Toggle Failed!');
                    }
                }
                else {
                    alert('Problem Does Not Exist!');
                }
            }
        });
    }
    onApplyProItem(proitem) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Apply Problem?')) {
                if (this.current_proset !== null) {
                    if ((yield API.setProItem(this.current_proset.uid, proitem)) === 'Success') {
                        alert('Apply Success!');
                    }
                    else {
                        alert('Apply Failed!');
                    }
                }
                else {
                    alert('Problem Does Not Exist!');
                }
            }
        });
    }
    onRemoveProItem(proitem) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Remove Problem?')) {
                if (this.current_proset !== null) {
                    if ((yield API.removeProItem(this.current_proset.uid, proitem.uid)) === 'Success') {
                        let index = this.current_proitems.indexOf(proitem);
                        this.current_proitems.splice(index, 1);
                        alert('Remove Success!');
                    }
                    else {
                        alert('Remove Failed!');
                    }
                }
                else {
                    alert('Problem Does Not Exist!');
                }
            }
        });
    }
};
__decorate([
    Watch('$route'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], GroupManage.prototype, "fetchData", null);
GroupManage = __decorate([
    Component
], GroupManage);
export default GroupManage;



// WEBPACK FOOTER //
// ./src/GroupManage.vue